var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { sprintf } from "sprintf-js";
import { convertUnit, getFilenameOnly, makeNPageIdStr } from "../../../common";
import NcodeFetcherPool from "../../NcodeGenerator/NcodeFetcherPool";
import drawNcodeOnCanvas from "./drawNcodeOnCanvas";
const _debugMode = 0;
export function generateDownloadableFileName(filename, pageInfo, extension) {
    const name = getFilenameOnly(filename);
    const { section, owner, book, page } = pageInfo;
    const fn = `${name}_(${section}_${owner}_${book}_${page})_ncoded.${extension}`;
    return fn;
}
function putNcodeInfo(context, printPageInfo) {
    const { x, y, width, height } = context;
    const pagePrintCodeStr = makeNPageIdStr(printPageInfo);
    const code_str = "p:" + pagePrintCodeStr; //makeNPageIdStr(pageInfo);
    const info_str = sprintf("%s", code_str);
    const ctx = context.ctx;
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(-Math.PI / 2);
    ctx.fillStyle = "#0000ff";
    ctx.font = "40px Arial";
    ctx.textBaseline = "bottom";
    // ctx.fillText(info_str, -height + 30, width - 20);
    ctx.fillText(info_str, -height + 150, width - 150);
    ctx.restore();
}
export function putNcodeOnCanvas(arg) {
    return __awaiter(this, void 0, void 0, function* () {
        const { canvas, sobp_for_print, ncodeUrl, dpi } = arg;
        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;
        const ctx = canvas.getContext("2d");
        const drawingContext = {
            ctx,
            x: 0,
            y: 0,
            width: canvasWidth,
            height: canvasHeight,
        };
        ctx.save();
        // pagesPerSheet에 따라 필요한 영역을 그린다. 단, areas.length <= pagesPerSheet, 항상 같을 수는 없다.
        const assignedNcode = sobp_for_print;
        const assignedUrl = ncodeUrl;
        const fetcher = NcodeFetcherPool.getInstance();
        // const fetcher = new NcodeFetcher(pageInfo);
        const ncodeSurfaceDesc = yield fetcher.getNcodeData(assignedNcode, assignedUrl);
        // 코드 정보를 찍어 넣는다.
        putNcodeInfo(drawingContext, assignedNcode);
        // 코드 점을 찍는다
        const ncodeArea = yield drawNcodeOnCanvas(drawingContext, ncodeSurfaceDesc, dpi, { left: 0, top: 0 }, _debugMode);
        ctx.restore();
        const result = {
            canvas,
            canvasAreas: {
                rotation: 0,
                areas: [
                    {
                        unit: "600dpi",
                        dpi: dpi,
                        x: 0,
                        y: 0,
                        width: canvasWidth,
                        height: canvasHeight,
                    }
                ]
            },
            ncodeAreas: [
                {
                    success: ncodeArea.success,
                    dpi: dpi,
                    pixelsPerDot: ncodeArea.pixelsPerDot,
                    dotsPerCell: ncodeArea.dotsPerCell,
                    rect: ncodeArea.rect,
                    pageInfo: assignedNcode,
                    basePageInfo: assignedNcode,
                }
            ],
        };
        return result;
    });
}
export function generateNcodePlane(mediaSize, sobp_for_print, ncodeUrl) {
    return __awaiter(this, void 0, void 0, function* () {
        const canvasWidth = convertUnit(mediaSize.unit, mediaSize.width, "600dpi");
        const canvasHeight = convertUnit(mediaSize.unit, mediaSize.height, "600dpi");
        // 캔버스를 준비
        const canvas = document.createElement("canvas");
        canvas.width = canvasWidth;
        canvas.height = canvasHeight;
        const ctx = canvas.getContext("2d");
        // const drawingContext: INcodeDrawContext = {
        //   ctx,
        //   x: 0,
        //   y: 0,
        //   width: canvasWidth,
        //   height: canvasHeight,
        // };
        ctx.save();
        ctx.fillStyle = "rgba(255, 255, 255, 255)"; // 투명 캔버스
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.restore();
        return yield putNcodeOnCanvas({ canvas, sobp_for_print, ncodeUrl, dpi: 600 });
    });
}
//# sourceMappingURL=prepareNcodeSurface.js.map